import type { FunctionComponent } from 'react';

import { Separator } from '@/components/atoms/Separator';
import { File } from '../../../../common/icons/lucide-adapter';

type FileDetailsProps = {
  dateRange?: { start: string; end: string };
  websitesCount?: number;
  totalTransactions?: number;
  merchantId?: string;
};

export const FileDetails: FunctionComponent<FileDetailsProps> = ({
  dateRange,
  websitesCount,
  totalTransactions,
  merchantId,
}) => {
  if (!dateRange && websitesCount === undefined && totalTransactions === undefined && !merchantId) {
    return null;
  }

  return (
    <div className="flex items-center gap-3 rounded-full border border-gray-200 bg-white px-4 py-2 shadow-sm">
      <div className="flex items-center gap-2">
        <File size={16} className="text-gray-500" />
        <span className="text-xs font-bold">File Details</span>
      </div>
      {dateRange && (
        <>
          <Separator orientation="vertical" className="h-4" />
          <div className="flex items-center gap-1.5 text-xs text-gray-600">
            <span className="font-medium">Date Range:</span>
            <span>
              {dateRange.start} - {dateRange.end}
            </span>
          </div>
        </>
      )}
      {websitesCount !== undefined && (
        <>
          <Separator orientation="vertical" className="h-4" />
          <div className="flex items-center gap-1.5 whitespace-nowrap text-xs text-gray-600">
            <span className="font-medium">No. of Websites:</span>
            <span>{websitesCount.toLocaleString()}</span>
          </div>
        </>
      )}
      {totalTransactions !== undefined && (
        <>
          <Separator orientation="vertical" className="h-4" />
          <div className="flex items-center gap-1.5 text-xs text-gray-600">
            <span className="font-medium">No. of Transactions:</span>
            <span>{totalTransactions.toLocaleString()}</span>
          </div>
        </>
      )}
      {merchantId && (
        <>
          <Separator orientation="vertical" className="h-4" />
          <div className="flex items-center gap-1.5 text-xs text-gray-600">
            <span className="font-medium">Merchant-ID:</span>
            <span>{merchantId}</span>
          </div>
        </>
      )}
    </div>
  );
};
